var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    clipPath: "url(#clip0_57_2160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.543945 34.8467C0.543945 16.069 15.7663 0.84668 34.5439 0.84668C53.3217 0.84668 68.5439 16.069 68.5439 34.8467C68.5439 53.6245 53.3217 68.8467 34.5439 68.8467C15.7663 68.8467 0.543945 53.6245 0.543945 34.8467Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51.9196 26.4503C51.5025 24.8481 50.2736 23.5862 48.7132 23.1581C45.8853 22.3799 34.5441 22.3799 34.5441 22.3799C34.5441 22.3799 23.2032 22.3799 20.3751 23.1581C18.8146 23.5862 17.5856 24.8481 17.1686 26.4503C16.4109 29.3541 16.4109 35.4131 16.4109 35.4131C16.4109 35.4131 16.4109 41.4719 17.1686 44.3762C17.5856 45.9784 18.8146 47.24 20.3751 47.6684C23.2032 48.4466 34.5441 48.4466 34.5441 48.4466C34.5441 48.4466 45.8853 48.4466 48.7132 47.6684C50.2736 47.24 51.5025 45.9784 51.9196 44.3762C52.6776 41.4719 52.6776 35.4131 52.6776 35.4131C52.6776 35.4131 52.6776 29.3541 51.9196 26.4503Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.1448 41.6467V30.3135L40.2115 35.9804L31.1448 41.6467Z",
    fill: "#DC6200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(0.543945 0.84668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.60116cb6d1c94de1194f5aa0e421e76f.svg";
export { ForwardRef as ReactComponent };